import request from '../requst'

//基础数据接口
export function get(url, data) {
    return request.get(`/${url}`, data);
}



export function post(url, data) {
    return request.post(`/${url}`, data);
}


// WEBPACK FOOTER //
// ./src/api/security/securityRequest.js